export default "__VITE_ASSET__ue5qCgUh__"